import { useState, useEffect } from 'react';

const DEFAULT_NATIVE_LOCK_USD = 0.5;

/**
 * Hook for managing native token lock amount (USD) persisted in localStorage
 */
export const useNativeLockUsd = () => {
  const [nativeLockUsd, setNativeLockUsd] = useState<number>(() => {
    try {
      const saved = typeof window !== 'undefined' ? localStorage.getItem('native_lock_usd') : null;
      const parsed = saved ? Number(saved) : DEFAULT_NATIVE_LOCK_USD;
      return isNaN(parsed) || parsed < 0 ? DEFAULT_NATIVE_LOCK_USD : parsed;
    } catch (_) {
      return DEFAULT_NATIVE_LOCK_USD;
    }
  });

  useEffect(() => {
    try {
      if (typeof window !== 'undefined') {
        localStorage.setItem('native_lock_usd', String(nativeLockUsd));
      }
    } catch (_) {
      // Ignore localStorage errors
    }
  }, [nativeLockUsd]);

  return [nativeLockUsd, setNativeLockUsd] as const;
};

